import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import { Badge } from 'react-bootstrap'
import PlayerImg from '@shared/components/playerImg'
import { getImgURL, numDifferentiation } from '@shared/utils'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.jpg'
import { AUCTION_PLAYER_SLUG } from '@shared/constants'
import CustomLink from '@shared/components/customLink'

const AuctionPlayer = ({ className = '', player, slug, showCapped = true }) => {
  const teamURL = player?.oPrimaryTeam?.oImg?.sUrl || player?.oCountry?.oImg?.sUrl
  return (
    <div className={`${styles.card} ${className} light-bg br-lg position-relative`} id={player?._id}>
      <div className={`${styles.head} d-flex align-items-center`}>
        <div className="d-flex gap-2 gap-md-3 align-items-start flex-grow-1">
          <div className={`${styles.playerImg} mx-auto rounded-circle flex-shrink-0 overflow-hidden`}>
            <PlayerImg head={player?.oPlayer?.oImg} jersey={player?.oPrimaryTeam?.oJersey} enableBg />
          </div>
          <div className="flex-grow-1">
            <h5 className="mb-1 mb-md-2 d-flex align-items-center gap-1 gap-md-2">{player?.oPlayer?.sFullName}</h5>
            <div className={`${styles.info} d-flex align-items-center`}>
              {teamURL && (
                <div className="d-flex align-items-center">
                  <span className={`${styles.flag} me-2 me-sm-2 rounded-circle overflow-hidden flex-shrink-0`}>
                    <MyImage
                      src={teamURL ? getImgURL(teamURL) : teamPlaceholder}
                      width="48"
                      height="48"
                      alt={
                        (player?.oPrimaryTeam ? player?.oPrimaryTeam?.oImg?.sText : player?.oCountry?.oImg?.sText) ||
                        player?.oPlayer?.sFullName
                      }
                    />
                  </span>
                  {player?.oPrimaryTeam?.sTitle || player?.oCountry?.sTitle}
                </div>
              )}
              <span className="border-0 text-capitalize">{player?.sPlayingRole}</span>
              {showCapped && (
                <Badge className={`${player?.bCappedPlayer ? styles.capped : styles.uncapped} px-1 text-capitalize`}>
                  {player?.bCappedPlayer ? 'Capped' : 'Uncapped'}
                </Badge>
              )}
            </div>
          </div>
        </div>
        {/* {player?.eAuctionStatus === '' && <Badge bg="danger" className={`${styles.badge}`}>Live</Badge>} */}
        {player?.eAuctionStatus === 's' && (
          <Badge bg="danger" className={`${styles.badge} ${styles.sold}`}>
            Sold
          </Badge>
        )}
        {player?.eAuctionStatus === 'us' && (
          <Badge bg="danger" className={`${styles.badge} ${styles.unsold}`}>
            UnSOLD
          </Badge>
        )}
        {player?.eAuctionStatus === 'r' && (
          <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
            Retained
          </Badge>
        )}
        {player?.eAuctionStatus === 'rtm' && (
          <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
            RTM
          </Badge>
        )}
        {player?.eAuctionStatus === 't' && (
          <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
            Transferred
          </Badge>
        )}
        {player?.eAuctionStatus === 'b' && (
          <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
            Bidding
          </Badge>
        )}
        {player?.eAuctionStatus === 'd' && (
          <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
            Draft
          </Badge>
        )}
      </div>
      <div className={`${styles.prices} d-flex align-items-center justify-content-around text-center`}>
        {player?.nBasePrice && (
          <div>
            <p className="font-semi mb-0">Base Price</p>
            <h6 className="fw-bold mb-0">{numDifferentiation(player?.nBasePrice)}</h6>
          </div>
        )}
        {player?.nSoldPrice && (
          <div>
            <p className="font-semi mb-0">Final Price</p>
            <h6 className="fw-bold mb-0">{numDifferentiation(player?.nSoldPrice)}</h6>
          </div>
        )}
        {player?.oTeam && (
          <div>
            <p className="font-semi mb-0">Team</p>
            <h6 className="fw-bold mb-0">
              <div className="d-flex align-items-center">
                <span className={`${styles.flag} me-2 rounded-circle overflow-hidden flex-shrink-0`}>
                  <MyImage
                    src={player?.oTeam?.oImg?.sUrl ? getImgURL(player?.oTeam?.oImg?.sUrl) : teamPlaceholder}
                    width="48"
                    height="48"
                    alt={player?.oTeam?.oImg?.sText || player?.oTeam?.sAbbr || 'Team'}
                  />
                </span>
                {player?.oTeam?.sAbbr}
              </div>
            </h6>
          </div>
        )}
      </div>
      {slug && (
        <>
          <CustomLink href={`/${slug}/${AUCTION_PLAYER_SLUG}${player?._id}`} className="position-absolute top-0 start-0 w-100 h-100 opacity-0">
            {player?.oPlayer?.sFullName}
          </CustomLink>
        </>
      )}
    </div>
  )
}
AuctionPlayer.propTypes = {
  className: PropTypes.string,
  player: PropTypes.object,
  slug: PropTypes.string,
  showCapped: PropTypes.bool
}

export default AuctionPlayer
